import { useState } from "react";
import { Banner } from "../Banner";
import styles from "./TokenReveal.module.css";

export type TokenRevealProps = {
  token: string;
  label?: string;
};

export const TokenReveal = ({ token, label = "Edge agent API key" }: TokenRevealProps) => {
  const [copied, setCopied] = useState(false);

  const copy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(token);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Banner
      tone="warn"
      title={label}
      actions={
        <button type="button" className={styles.copyBtn} onClick={copy}>
          {copied ? "Copied" : "Copy"}
        </button>
      }
    >
      <p className={styles.note}>
        Shown once — copy it now and keep it safe. You'll need it when setting up this store's
        device, and it can't be retrieved later (only re-issued).
      </p>
      <code className={styles.token}>{token}</code>
    </Banner>
  );
};
